import styled from 'styled-components';

const RouteTitle = styled.h2.attrs({
    className: 'text-start'
})`
`;

const RouteSubTitle = styled.h5.attrs({
	className: 'text-start text-secondary',
})``

export { RouteTitle, RouteSubTitle }